import { Component, OnInit, ViewChild } from '@angular/core';
import { LoggerService } from '@services/logger/logger.service';
import { TranslateService } from '@ngx-translate/core';
import { FeatureType } from '@app/core/enums/feature-type.enum';
import { UploadMeasurementsModalComponent } from '@app/shared/modals/admin/upload-measurements-modal/upload-measurements-modal.component';
import { DataService } from '@app/core/services/api';
import * as _ from 'lodash';
import { firstValueFrom } from 'rxjs';

@Component({
  standalone: false,
    selector: 'app-admin',
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.scss']
})

export class AdminComponent implements OnInit {
    @ViewChild(UploadMeasurementsModalComponent) modalComponent: UploadMeasurementsModalComponent;
    translations: any;
    adminLabel: any;
    homeLabel: any;
    tileTypes = [
        FeatureType.Admin,
        FeatureType.CastMeasurements,
        FeatureType.CreateCharacter
    ];
    tiles: any[] = [];

    constructor(
        private loggerService: LoggerService,
        private translateService: TranslateService,
        private dataService: DataService
    ) { }

    public breadCrumb: any;
    public toolCount: any;

    public async ngOnInit() {
        this.loggerService.log(`Loaded Admin Screen`);
        // assign translatins
        this.getTranslations();
        this.toolCount = document.querySelectorAll('.links').length;
    }

    public async getTranslations() {
        const translations = await firstValueFrom(this.translateService.get([
            'Breadcrumb.Home',
            'Breadcrumb.Admin']));

        this.translations = translations;
        this.homeLabel = this.translations['Breadcrumb.Home'];
        this.adminLabel = this.translations['Breadcrumb.Admin'];

        // set breadcrumb navgation
        this.breadCrumb = [
            {
                label: this.homeLabel,
                icon: 'di di-home',
                url: 'home'
            },
            {
                label: this.adminLabel,
                url: 'admin'
            }
        ];
    }

    openUploadModal() {
        this.modalComponent.open();
    }

    async getAllMeasurements() {
        const promises = [];
        const finalResult = [];
        const paths = await firstValueFrom(this.dataService.getAllMeasurements());
        for (const path of paths) {
            promises.push(firstValueFrom(this.dataService.getMeasurementOffset(path)));
        }
        await Promise.all(promises).then(results => {
            _.each(results, item => {
                _.each(item, a => {
                    finalResult.push(a);
                });
            });
        });
        const result = [];
        _.each(finalResult, item => {
            let measurement = _.omit(item, [
                'measurements'
            ]);
            result.push(measurement);
            measurement = _.merge(measurement, _.get(item, 'measurements', {}));
        });
        const toCSV = this.arrayToCSV(result);
        const file = document.createElement('a');
        const blob = new Blob([toCSV], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        file.href = url;
        const dateNow = this.getCurrentDate();
        file.download = 'Casts_Data_Export-' + dateNow + '.csv';
        file.click();
        window.URL.revokeObjectURL(url);
        file.remove();
    }

    async getAllCharacterMeasurements() {
        const promises = [];
        const finalResult = [];
        const paths = await firstValueFrom(this.dataService.getAllCharacterMeasurements());
        for (const path of paths) {
            promises.push(firstValueFrom(this.dataService.getMeasurementOffset(path)));
        }
        await Promise.all(promises).then(results => {
            _.each(results, item => {
                _.each(item, a => {
                    finalResult.push(a);
                });
            });
        });
        const result = [];
        _.each(finalResult, item => {
            let measurement = _.omit(item, [
                'measurements'
            ]);
            result.push(measurement);
            measurement = _.merge(measurement, _.get(item, 'measurements', {}));
        });
        const toCSV = this.arrayToCSV(result);
        const file = document.createElement('a');
        const blob = new Blob([toCSV], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        file.href = url;
        const dateNow = this.getCurrentDate();
        file.download = 'Characters_Data_Export-' + dateNow + '.csv';
        file.click();
        window.URL.revokeObjectURL(url);
        file.remove();
    }

    arrayToCSV = (arr) => {
        const keys = Object.keys(arr[0]);
        const replacer = (_key, value) => value === null ? '' : value;
        const processRow = row => keys.map(key => JSON.stringify(row[key], replacer)).join(',');

        return [keys.join(','), ...arr.map(processRow)].join('\r\n');
    };

    getCurrentDate() {
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const yyyy = today.getFullYear();
        const dateNow = mm + dd + yyyy;

        return dateNow;
    }
}
